// extracted by mini-css-extract-plugin
export default {"pdf":"MeetingPDF_pdf__2KeXf","full":"MeetingPDF_full__6GqYO"};